import React, { useContext, useEffect, useState } from 'react'
import Icons from '../../components/Icons'
import CreateNewGallery from './CreateNewGallery'
import Layout from './LayoutGallery'; 
import { Context } from "../contexts/AppContext";
import GalleryThumbnail from './GalleryThumbnail';
import Uploadvideo from './UploadVideo';
import GalleryHeader from './GalleryHeader';

function GalleryManager({selectedFolder}) {    
 
    const [videoUploadPage, setVideoUploadPage] = useState(false)
    const [showLayout,setShowLayout]=useState(false)
    const { value } = useContext(Context);
    const [appState, setAppState] = value;
    const [newGalleryBtnClicked,setNewGalleryBtnClicked]=useState(false)
    const [galleryThumbnailPage,setGalleryThumbNailPage]=useState(true)

    useEffect(()=>{
     
setShowLayout(false)
    },[])
  
     

    useEffect(()=>{
      
      if(appState.currentGalleryName)
      {
        setShowLayout(false)
        setVideoUploadPage(true)
      }
      
    },[appState?.currentGalleryName])
 

  
    const layoutSelected=()=>{
      setAppState((prevState) => ({ ...prevState,
        modalData:{ ...prevState.modalData, type: "NewGalleryModal", isOpen: true, galeryUpdate:true}}
      ));
    }
    const uploadVideoPage =()=>{ 
      setGalleryThumbNailPage(false)
      setVideoUploadPage(true)
    }
    
    const closeCreateNewGalleryPage=()=>{
      setNewGalleryBtnClicked(true)
      setShowLayout(true)
      
    }
  return (
   <div>  

 
  <GalleryHeader/>
    {appState?.allFolderData[appState.currentFolderId]?.galleries.length<=0 && newGalleryBtnClicked==false?<div className='flex flex-col justify-center border h-[calc(100vh-140px)] items-center'>
      <div className='p-4'><b>No galleries added yet</b></div>
      <CreateNewGallery closeCreateNewGalleryPage={closeCreateNewGalleryPage}/></div>:null}
    {showLayout && <Layout layoutSelected={layoutSelected} />}
     {appState?.allFolderData[appState.currentFolderId]?.galleries.length>0 && galleryThumbnailPage? <GalleryThumbnail uploadVideoPage={uploadVideoPage}/>:null}  
     {videoUploadPage && <Uploadvideo  />}
    
   </div>

  )
}

export default GalleryManager